export const mapUser = (data) => {
  const { id, email, username } = data;
  // TODO: check whether roles are array on the backend, hot fix of #131900
  const roles = Array.isArray(data.roles) ? data.roles : Object.values(data.roles);

  return { id, email, username, roles };
};
